import { Formik, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../config";
import axios from "axios";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

const Settings = () => {
  const [settings, setSettings] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const authToken = userDetails?.data?.auth_token;
  const collegeId = useSelector((state) => state.college_id.college_id);
  const fetchSettings = async () => {
    setIsLoading(true);
    try {
      // https://govtjobsapi.governmentjobsforgraduates.com/api/freshment_portal_apis/College/get_college_settings
      const response = await axios.get(
        `${API_URL}/api/freshment_portal_apis/College/get_college_settings`,
        {
          params: {
            college_id: collegeId,
          },
          headers: { Authorization: authToken },
        },
      );
      if (response.data.success) {
        setSettings(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchSettings();
  }, []);
  const formik = useFormik({
    initialValues: {
      twoFactorAuthentication: settings?.is_two_factor_enabled === "1",
      studentEmailNotification: settings?.notify_students_on_job_email === "1",
      tpoEmailNotification: settings?.notify_tpo_on_job_email === "1",
      collegeEmailNotification:
        settings?.enable_send_notifications_on_job_details === "1",
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      console.log(values);
      const params = {
        college_id: collegeId,
        is_two_factor_enabled: values.twoFactorAuthentication ? "1" : "0",
        notify_students_on_job_email: values.studentEmailNotification
          ? "1"
          : "0",
        notify_tpo_on_job_email: values.tpoEmailNotification ? "1" : "0",
        enable_send_notifications_on_job_details:
          values.collegeEmailNotification ? "1" : "0",
      };
      const formData = new FormData();
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key]);
      });
      try {
        const response = await axios.post(
          `${API_URL}/api/freshment_portal_apis/College/save_college_settings`,
          formData,
          { headers: { Authorization: authToken } },
        );
        if (response.data.success) {
          toast.success(response.data.message || "Settings saved successfully");
        } else {
          toast.error(response.data.message || "Something went wrong");
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong");
      }
    },
  });

  return (
    <div className="card" style={{ height: "fit-content" }}>
      <div className="card-header border-0 pb-0">
        <h4 className="fs-20 font-w600">Settings</h4>
      </div>
      {isLoading ? (
        <div className="card-body text-center py-5">
          <Spinner
            animation="border"
            role="status"
            variant="primary"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-3">Loading settings...</p>
        </div>
      ) : (
        <Formik initialValues={formik.initialValues}>
          <form onSubmit={formik.handleSubmit}>
            <div className="card-body">
              <div className="settings-options">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h5 className="mb-1 pe-1 fs-14">
                      Two Factor Authentication
                    </h5>
                  </div>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input form-check-input-lg"
                      type="checkbox"
                      id="twoFactorSwitch"
                      style={{ width: "3rem", height: "1.5rem" }}
                      name="twoFactorAuthentication"
                      onChange={formik.handleChange}
                      checked={formik.values.twoFactorAuthentication}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h5 className="mb-1 pe-1 fs-14">
                      Send Jobs Email Notification (Students)
                    </h5>
                  </div>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input form-check-input-lg"
                      type="checkbox"
                      id="studentEmailSwitch"
                      style={{ width: "3rem", height: "1.5rem" }}
                      name="studentEmailNotification"
                      onChange={formik.handleChange}
                      checked={formik.values.studentEmailNotification}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h5 className="mb-1 pe-1 fs-14">
                      Send Jobs Email Notification (College)
                    </h5>
                  </div>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input form-check-input-lg"
                      type="checkbox"
                      id="tpoEmailSwitch"
                      style={{ width: "3rem", height: "1.5rem" }}
                      name="tpoEmailNotification"
                      onChange={formik.handleChange}
                      checked={formik.values.tpoEmailNotification}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h5 className="mb-1 pe-1 fs-14">
                      Send Student Notification (Job Details)
                    </h5>
                  </div>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input form-check-input-lg"
                      type="checkbox"
                      id="collegeEmailSwitch"
                      style={{ width: "3rem", height: "1.5rem" }}
                      name="collegeEmailNotification"
                      onChange={formik.handleChange}
                      checked={formik.values.collegeEmailNotification}
                    />
                  </div>
                </div>

                <div className="mt-4">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={formik.isSubmitting}
                  >
                    {formik.isSubmitting ? "Saving..." : "Save Settings"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </Formik>
      )}
    </div>
  );
};

export default Settings;
